// UI strings for the EGI additions (shipments, invoices, performance, login links).
// English is the source; Chinese mirrors the same keys.
export const englishEgiMessagesFlat: Record<string, string> = {
  "resources.shipments.name": "Shipment |||| Shipments",
  "egi.nav.shipments": "Shipments",
  "egi.nav.performance": "Performance",
  "egi.shipments.new": "New shipment",
  "egi.shipments.new_short": "Shipment",
  "egi.shipments.edit": "Edit shipment",
  "egi.shipments.page_total": "Active total on this page:",
  "egi.shipments.back": "Back to shipments",
  "egi.shipments.void": "Void",
  "egi.shipments.restore": "Restore",
  "egi.shipments.void_confirm":
    "Void %{number}? It will no longer count toward sales.",
  "egi.shipments.voided": "Shipment voided",
  "egi.shipments.restored": "Shipment restored",
  "egi.shipments.update_failed": "Update failed",
  "egi.fields.invoice_number": "Invoice no.",
  "egi.fields.date": "Date",
  "egi.fields.invoice_date": "Invoice date",
  "egi.fields.customer": "Customer",
  "egi.fields.contact": "Contact (optional)",
  "egi.fields.salesperson": "Salesperson",
  "egi.fields.total": "Total",
  "egi.fields.status": "Status",
  "egi.fields.products": "Products shipped",
  "egi.fields.product": "Product",
  "egi.fields.details": "Details",
  "egi.fields.quantity": "Qty (pcs)",
  "egi.fields.unit_price": "Unit price",
  "egi.fields.amount": "Amount",
  "egi.fields.tax": "Sales tax",
  "egi.fields.subtotal": "Subtotal",
  "egi.fields.notes": "Internal notes",
  "egi.status.active": "Active",
  "egi.status.void": "Void",
  "egi.invoice.download": "Invoice PDF",
  "egi.invoice.preview": "Preview",
  "egi.invoice.preparing": "Preparing...",
  "egi.invoice.failed": "Invoice download failed: %{error}",
  "egi.performance.title": "Sales performance",
  "egi.performance.from": "From",
  "egi.performance.to": "To",
  "egi.performance.note":
    "Counted by invoice date. Voided shipments are excluded.",
  "egi.performance.own_only": "You only see your own shipments.",
  "egi.performance.total_sales": "Total sales",
  "egi.performance.shipments": "Shipments",
  "egi.performance.owner_share": "Connor share (5% of external sales)",
  "egi.performance.share_excludes": "Excludes %{amount} of intercompany trades",
  "egi.trade_type.label": "Trade type",
  "egi.trade_type.external": "External",
  "egi.trade_type.intercompany": "Intercompany",
  "egi.lead_source.label": "Lead source",
  "egi.lead_source.unknown": "Not recorded",
  "egi.lead_source.settings_title": "Lead sources",
  "egi.lead_source.settings_help":
    "Where buyers found us. Pick one on each contact; add or rename channels here.",
  "egi.lead_source.detail": "Source detail",
  "egi.lead_source.detail_help":
    "Which group, post or referrer, e.g. FB group · Liquidation Pallets. Pick an existing one when it shows up.",
  "egi.channels.title": "Lead sources",
  "egi.channels.note":
    "Inquiries = contacts created in this period. Buyers and sales come from non-voided shipments invoiced in this period, matched by the shipment's contact. Click a channel to see each source detail.",
  "egi.channels.channel": "Channel",
  "egi.channels.inquiries": "Inquiries",
  "egi.channels.buyers": "Buyers",
  "egi.channels.external": "External sales",
  "egi.channels.intercompany": "Intercompany sales",
  "egi.channels.no_detail": "No detail recorded",
  "egi.channels.no_contact": "Shipment has no contact",
  "egi.channels.toggle": "Show or hide source details",
  "egi.performance.loading": "Loading...",
  "egi.performance.empty": "No shipments in this period.",
  "egi.performance.all": "All",
  "egi.login_link.copy": "Copy login link",
  "egi.login_link.generating": "Generating...",
  "egi.login_link.copied":
    "Login link for %{email} copied. Send it to them; it works once.",
  "egi.login_link.prompt": "Login link for %{email} (works once):",
  "egi.login_link.failed": "Could not generate the login link",
  "egi.language.switch": "中文",
  "egi.sign.from": "Invoice from Base Camp International Inc",
  "egi.sign.invoice": "Invoice",
  "egi.sign.bill_to": "Bill to",
  "egi.sign.download": "Download PDF",
  "egi.sign.full_name": "Your full name",
  "egi.sign.signature": "Signature",
  "egi.sign.draw_here": "Sign here with your finger or mouse",
  "egi.sign.clear": "Clear",
  "egi.sign.consent":
    "I agree to sign this invoice electronically, and that my electronic signature has the same legal effect as a handwritten signature. I confirm the goods listed above were received and I accept the terms: all sales are final, no refunds or returns.",
  "egi.sign.submit": "Sign invoice",
  "egi.sign.signing": "Signing...",
  "egi.sign.done": "This invoice is signed. Thank you.",
  "egi.sign.signed_by": "Signed by %{name} on %{date}",
  "egi.sign.invalid":
    "This signing link is not valid. Please ask Base Camp for a new link.",
  "egi.sign.not_signed": "Not signed yet. Send the customer a signing link.",
  "egi.sign.copy_link": "Copy signing link",
  "egi.sign.link_copied": "Signing link copied. Send it to the customer.",
  "egi.sign.link_prompt": "Signing link for the customer:",
  "egi.sign.clear_signature": "Clear signature",
  "egi.sign.clear_confirm":
    "Clear this signature? The invoice can then be edited, and the customer must sign again with a new link.",
  "egi.sign.cleared": "Signature cleared",
  "egi.sign.fingerprint": "fingerprint",
  "egi.sign.badge": "Signed",
  "egi.language.switch_label": "Switch to Chinese",
};

export const chineseEgiMessagesFlat: Record<string, string> = {
  "resources.shipments.name": "出货单",
  "egi.nav.shipments": "出货单",
  "egi.nav.performance": "业绩",
  "egi.shipments.new": "新建出货单",
  "egi.shipments.new_short": "出货单",
  "egi.shipments.edit": "编辑出货单",
  "egi.shipments.page_total": "本页正常单合计：",
  "egi.shipments.back": "返回出货单",
  "egi.shipments.void": "作废",
  "egi.shipments.restore": "恢复",
  "egi.shipments.void_confirm": "确定作废 %{number}？作废后不再计入业绩。",
  "egi.shipments.voided": "已作废",
  "egi.shipments.restored": "已恢复",
  "egi.shipments.update_failed": "更新失败",
  "egi.fields.invoice_number": "发票号",
  "egi.fields.date": "日期",
  "egi.fields.invoice_date": "开票日期",
  "egi.fields.customer": "客户",
  "egi.fields.contact": "联系人（可选）",
  "egi.fields.salesperson": "销售",
  "egi.fields.total": "合计",
  "egi.fields.status": "状态",
  "egi.fields.products": "发货明细",
  "egi.fields.product": "品名",
  "egi.fields.details": "规格说明",
  "egi.fields.quantity": "数量（件）",
  "egi.fields.unit_price": "单价",
  "egi.fields.amount": "金额",
  "egi.fields.tax": "销售税",
  "egi.fields.subtotal": "小计",
  "egi.fields.notes": "内部备注",
  "egi.status.active": "正常",
  "egi.status.void": "已作废",
  "egi.invoice.download": "发票 PDF",
  "egi.invoice.preview": "预览",
  "egi.invoice.preparing": "生成中...",
  "egi.invoice.failed": "发票下载失败：%{error}",
  "egi.performance.title": "销售业绩",
  "egi.performance.from": "从",
  "egi.performance.to": "到",
  "egi.performance.note": "按开票日期统计，不含已作废的单。",
  "egi.performance.own_only": "你只能看到自己的出货单。",
  "egi.performance.total_sales": "总销售额",
  "egi.performance.shipments": "出货单数",
  "egi.performance.owner_share": "Connor 分成（外部销售额 5%）",
  "egi.performance.share_excludes": "已扣除内部交易 %{amount}",
  "egi.trade_type.label": "交易类型",
  "egi.trade_type.external": "外部交易",
  "egi.trade_type.intercompany": "内部交易",
  "egi.lead_source.label": "来源渠道",
  "egi.lead_source.unknown": "未填写",
  "egi.lead_source.settings_title": "来源渠道",
  "egi.lead_source.settings_help":
    "买家是从哪里认识我们的。每个联系人选一个；渠道在这里增加或改名。",
  "egi.lead_source.detail": "来源明细",
  "egi.lead_source.detail_help":
    "具体哪个群、哪条帖子、谁介绍的，例如「FB群·Liquidation Pallets」。下拉里有现成的就直接选。",
  "egi.channels.title": "渠道统计",
  "egi.channels.note":
    "询盘人数 = 这段时间新建的联系人数。成交客户数和成交金额按出货单的联系人归渠道，只算开票日在这段时间内、未作废的单。点渠道可展开看每个来源明细。",
  "egi.channels.channel": "渠道",
  "egi.channels.inquiries": "询盘人数",
  "egi.channels.buyers": "成交客户数",
  "egi.channels.external": "外部成交金额",
  "egi.channels.intercompany": "内部成交金额",
  "egi.channels.no_detail": "未填明细",
  "egi.channels.no_contact": "出货单未关联联系人",
  "egi.channels.toggle": "展开或收起来源明细",
  "egi.performance.loading": "加载中...",
  "egi.performance.empty": "这段时间没有出货单。",
  "egi.performance.all": "合计",
  "egi.login_link.copy": "复制登录链接",
  "egi.login_link.generating": "生成中...",
  "egi.login_link.copied":
    "已复制 %{email} 的登录链接，发给对方即可，只能用一次。",
  "egi.login_link.prompt": "%{email} 的登录链接（只能用一次）：",
  "egi.login_link.failed": "无法生成登录链接",
  "egi.language.switch": "EN",
  "egi.sign.from": "Base Camp International Inc 开具的发票",
  "egi.sign.invoice": "发票",
  "egi.sign.bill_to": "客户",
  "egi.sign.download": "下载 PDF",
  "egi.sign.full_name": "你的全名",
  "egi.sign.signature": "签名",
  "egi.sign.draw_here": "用手指或鼠标在这里签名",
  "egi.sign.clear": "清除",
  "egi.sign.consent":
    "我同意以电子方式签署本发票，并认可电子签名与手写签名具有同等法律效力。我确认已收到上列货物，并接受条款：所有销售均为最终交易，不退不换。",
  "egi.sign.submit": "签署发票",
  "egi.sign.signing": "签署中...",
  "egi.sign.done": "这张发票已签署，谢谢。",
  "egi.sign.signed_by": "%{name} 于 %{date} 签署",
  "egi.sign.invalid": "这个签名链接无效，请联系 Base Camp 要一条新链接。",
  "egi.sign.not_signed": "还未签名。把签名链接发给客户。",
  "egi.sign.copy_link": "复制签名链接",
  "egi.sign.link_copied": "签名链接已复制，发给客户即可。",
  "egi.sign.link_prompt": "客户的签名链接：",
  "egi.sign.clear_signature": "撤销签名",
  "egi.sign.clear_confirm":
    "确定撤销签名？撤销后发票可以修改，客户需要用新链接重新签。",
  "egi.sign.cleared": "签名已撤销",
  "egi.sign.fingerprint": "文件指纹",
  "egi.sign.badge": "已签",
  "egi.language.switch_label": "切换到英文",
};
